import { NgModule } from '@angular/core';
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';

@NgModule({
  declarations: [],
  imports: [BreadcrumbComponent, BreadcrumbItemDirective],
  exports: [BreadcrumbComponent, BreadcrumbItemDirective],
})
export class XngBreadcrumbModule {}
